<p-breadcrumb styleClass="p-mt-4" [model]="items" [home]="home"></p-breadcrumb>
<p-toast position="top-right" key="shipment-details"></p-toast>

<div class="card p-mt-3 p-shadow-2 p-px-4 p-py-2">


    <div class="p-grid">
        <!--        class]="screenSize > 1200 ?'p-grid' : 'p-d-flex scroll-width'"-->

        <!--        Start : Shipment Details-->
        <div class="p-col-12 p-xl-9">
            <!--            Start: Shipment Details Header-->
            <div class="p-grid divider-bottom p-ai-center p-jc-between p-py-2">
                <div class="p-col-12 p-md-4 p-xl-4 p-text-left">
                    <h5 class="p-m-0 p-text-primary">
                        Shipment Details -
                        ( {{shipmentType ? shipmentType + (movementType ? ' | ' + movementType : '') : '*n/a*'}} )
                    </h5>
                </div>
                <div class="p-col-12 p-md-8 p-xl-8">
                    <div class="p-d-flex p-ai-center p-jc-end" [class]="blNumbers?.length <= 1 ? 'p-py-2' : ''">
                        <div class="p-d-flex p-ai-center" *ngIf="blNumbers?.length > 1">
                            <div style="opacity: 50%;">
                                Choose BL Number
                            </div>
                            <div class="p-ml-2">
                                <p-dropdown (onChange)="onChangeOfBlNumber($event)" [ngModel]="selectedBlNumber"
                                            [style]="{width: '15rem'}" [options]="blNumbers" placeholder="BL Number"
                                            emptyMessage="No BL Found"></p-dropdown>
                            </div>
                        </div>
<!--                        <div class="p-ml-3">-->
<!--                            <img class="fp-icon-height" src="assets/branding/shared-icons/export-pdf.svg"-->
<!--                                 alt="pdf-export">-->
<!--                        </div>-->
<!--                        <div class="p-ml-3">-->
<!--                            <img class="fp-icon-height" src="assets/branding/shared-icons/export-excel.svg"-->
<!--                                 alt="excel-export">-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
            <!--            End: Shipment Details Header-->

            <!--            Start: Shipment Details Content-->
            <div class="p-mt-3 p-grid p-ai-start p-jc-start">

                <div class="p-col-12 p-py-5 p-text-center" [class]="isLoading ? '' : 'p-d-none'">
                    <div *ngIf="isLoading">
                        <div>
                            <i class="pi pi-spin pi-spinner p-text-secondary" style="font-size: 1.75rem;"></i>
                        </div>
                        <div class="p-text-secondary p-mt-3">
                            Loading Shipment Details !
                        </div>
                    </div>

                    <div *ngIf="shipmentDetails?.length === 0 && !isLoading">
                        <div class="p-text-secondary">
                            No Shipment Details Available !
                        </div>
                    </div>
                </div>

                <div class="p-col-12" *ngFor="let shipmentDetail of shipmentDetails; index as shipmentIndex">
                    <div class="p-grid" *ngIf="shipmentDetail?.show">
                        <div class="p-p-2 fp-shipment-header fp-text-bold">
                            {{shipmentDetail?.label}}
                        </div>
                        <div class="p-col-12 divider-top">
                            <div class="p-grid">
                                <div class="p-col-6 p-md-3 p-lg-4 p-xl-2 p-px-0"
                                     *ngFor="let column of shipmentDetail?.columns; index as i">
                                    <div class="p-pb-0 p-px-2 p-pt-0 fp-text-bold"
                                         [class.divider-bottom]="screenSize > 1200"
                                         [style]="screenSize > 1200 ? 'height: 4.7vh;' : ''"
                                         [class]="i > 5 && screenSize > 1200 ? 'divider-top p-pt-2' : ''">
                                        {{column?.columnLabel}}
                                    </div>
                                    <div class="p-py-2 p-px-2 p-text-wrap">
                                        {{column?.value ? column?.value : '-'}}
                                    </div>
                                </div>
                                <div *ngIf="screenSize > 1200" class="p-col p-px-0">
                                    <div class="p-py-2" style="height: 4.7vh;"
                                         [class.divider-bottom]="screenSize > 1200"
                                         [class]="shipmentDetail?.columns?.length > 5 && screenSize > 1200 ? 'divider-top' : ''">
                                        {{'&nbsp;'}}
                                    </div>
                                    <div class="p-py-2">
                                        {{'&nbsp;'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <!--            End: Shipment Details Content-->

        </div>
        <!--        End: Shipment Details-->

        <!--        Start: Shipment Tracking-->
        <div class="p-col-12 p-xl-3 p-pl-4">
            <shipment-tracking [display]="true" [bookingId]="bookingId"
                               [shipmentType]="shipmentType"></shipment-tracking>
        </div>
        <!--        End: Shipment Tracking-->
    </div>
</div>
